import React from 'react';
import { get } from 'lodash';
import type { Formik } from 'formik/dist/index';
import 'formik/dist/index';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { getOptinsInfos } from 'Components/widgets/contact-info/ContactInfoUtils';
import { FormikInput } from 'Components/frameworks/formik/FormikInput';
import { t } from 'Src/i18n';
type Props = {
  attendeeIdentifier: string;
  formik: Formik;
  i18n: I18N;
  isSeller: boolean;
};
export const Subscriptions = ({ attendeeIdentifier, formik, i18n, isSeller }: Props) => {
  const optins = getOptinsInfos(i18n.bookingProcess);
  const showOptinEmail = get(formik.values, `${attendeeIdentifier}.optinEmail`) !== undefined;
  const showOptinSms = get(formik.values, `${attendeeIdentifier}.optinSms`) !== undefined;
  const showOptinMail = get(formik.values, `${attendeeIdentifier}.optinMail`) !== undefined;
  const showOptinFosun = get(formik.values, `${attendeeIdentifier}.optinFosun`) !== undefined;
  const showOptinPhone = get(formik.values, `${attendeeIdentifier}.optinPhone`) !== undefined;
  const showOptinClubmedPlus =
    get(formik.values, `${attendeeIdentifier}.optinClubmedPlus`) !== undefined;
  const subscriptionTitle = isSeller
    ? t('booking.partners.participants.subscription.title')
    : t('booking.participants.subscription.title');

  if (
    !showOptinEmail &&
    !showOptinSms &&
    !showOptinMail &&
    !showOptinFosun &&
    !showOptinPhone &&
    !showOptinClubmedPlus
  ) {
    return null;
  }

  return (
    <fieldset className="mt-10 p-10 py-15" data-testid="participant-form-optionout">
      <div className="px-10 py-5 font-bold">{subscriptionTitle}</div>
      {showOptinEmail && optins.email && (
        <div className="px-10 py-5">
          <FormikInput
            iconColor={COLORS.BLACK}
            iconName={ICONS.INTERNET}
            label={optins.email.label}
            name={`${attendeeIdentifier}.optinEmail`}
            type="checkbox"
          />
        </div>
      )}
      {showOptinPhone && optins.phone && (
        <div className="px-10 py-5">
          <FormikInput
            iconColor={COLORS.BLACK}
            iconName={ICONS.PHONE}
            label={optins.phone.label}
            name={`${attendeeIdentifier}.optinPhone`}
            type="checkbox"
          />
        </div>
      )}
      {showOptinSms && optins.sms && (
        <div className="px-10 py-5">
          <FormikInput
            iconColor={COLORS.BLACK}
            iconName={ICONS.PHONE}
            label={optins.sms.label}
            name={`${attendeeIdentifier}.optinSms`}
            type="checkbox"
          />
        </div>
      )}
      {showOptinMail && optins.mail && (
        <div className="px-10 py-5">
          <FormikInput
            iconColor={COLORS.BLACK}
            iconName={ICONS.MAIL}
            label={optins.mail.label}
            name={`${attendeeIdentifier}.optinMail`}
            type="checkbox"
          />
        </div>
      )}
      {showOptinFosun && optins.fosun && (
        <div className="px-10 py-5">
          <FormikInput
            iconColor={COLORS.BLACK}
            label={optins.fosun.label}
            name={`${attendeeIdentifier}.optinFosun`}
            type="checkbox"
          />
        </div>
      )}
      {showOptinClubmedPlus && optins.clubmedPlus && (
        <div className="px-10 py-5">
          <FormikInput
            iconColor={COLORS.SAND}
            iconName={ICONS.CLUBMED_PLUS}
            label={optins.clubmedPlus.label}
            name={`${attendeeIdentifier}.optinClubmedPlus`}
            type="checkbox"
          />
        </div>
      )}
    </fieldset>
  );
};
